// Configurazione per modalità del motore di registrazione (TDD FE §4.1/§4.2, sprint 019 GD).
// getRegistrationConfig(mode) raccoglie tutti i punti di variazione tra il flusso PD (default)
// e il flusso GD-only, così che RegistrationPage resti un unico motore con rami additivi.
// Default = PD → nessuna regressione del flusso esistente.

const PD_CONFIG = {
  mode: 'PD',
  campaignType: 'PD',
  showGdCheckbox: true, // opzione "anche GD" presente nel flusso PD
  requireGdEntity: false, // entità master GD obbligatoria solo se gdCheck === true
  gdEntitySource: 'gd_registration',
  ageBounds: { min: 16, maxExclusive: null }, // registrazione PD: min 16
  useSingleRate: false, // PD applica lo sconto giovani (price_discounted)
  payload: {}, // nessun campaign_type nel body (default PD lato BE)
  header: {
    imageSrc: '/assets/images/img/tesseramento_2026_header.jpg',
    logoSrc: '/assets/images/img/logopd.png',
    title: 'Portale Tesseramento',
    subtitle: '',
  },
};

const GD_CONFIG = {
  mode: 'GD',
  campaignType: 'GD',
  showGdCheckbox: false, // in GD-only non c'è l'opzione "anche PD" (direzione PD → GD, R5/R19)
  requireGdEntity: true, // entità master GD sempre obbligatoria (R15/R19)
  gdEntitySource: 'gd_registration',
  ageBounds: { min: 14, maxExclusive: 30 }, // 14–29 estremi inclusi ⇔ >=14 && <30
  useSingleRate: true, // GD: tariffa singola, sempre price (mai price_discounted) (R2/G4)
  payload: { campaign_type: 'GD' }, // discriminante uniforme nel body POST /users
  header: {
    // Header dedicato GD.
    imageSrc: '/assets/images/img/tesseramento_gd_header.jpeg',
    logoSrc: '/assets/images/img/gd_logo.png',
    title: 'Portale Tesseramento GD',
    subtitle: 'Iscriviti ai Giovani Democratici',
  },
};

export function getRegistrationConfig(mode = 'PD') {
  return mode === 'GD' ? GD_CONFIG : PD_CONFIG;
}

// Eleggibilità GD in base all'età (anni compiuti), estremi inclusi 14–29.
export function isGdEligibleAge(age, bounds = GD_CONFIG.ageBounds) {
  if (age === null || age === undefined || Number.isNaN(age)) return false;
  const okMin = age >= bounds.min;
  const okMax = bounds.maxExclusive === null ? true : age < bounds.maxExclusive;
  return okMin && okMax;
}

// Messaggio 422 congelato dal cliente (contract §1) — usato anche lato client per coerenza.
export const GD_AGE_ERROR_MESSAGE = "L'iscrizione ai GD è riservata a chi ha tra 14 e 29 anni.";
export const GD_ENTITY_REQUIRED_MESSAGE = "Selezionare un'entità master GD.";
